import { render, staticRenderFns } from "./itemService2.vue?vue&type=template&id=71143706&scoped=true&"
import script from "./itemService2.vue?vue&type=script&lang=js&"
export * from "./itemService2.vue?vue&type=script&lang=js&"
import style0 from "./itemService2.vue?vue&type=style&index=0&id=71143706&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71143706",
  null
  
)

export default component.exports